import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import { commonArrowStyles, arrowGenerator } from "./styles";
var tooltopBackgroundColor = "#131E41";
var styles = {
  tooltip: {
    backgroundColor: tooltopBackgroundColor,
    padding: "6px 8px"
  },
  tooltipPlacementTop: {
    margin: "6px 0"
  },
  arrow: commonArrowStyles,
  popper: arrowGenerator(tooltopBackgroundColor)
};

var NameTooltip = function (_Component) {
  _inherits(NameTooltip, _Component);

  function NameTooltip() {
    var _temp, _this, _ret;

    _classCallCheck(this, NameTooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      arrowRef: null
    }, _this.handlePopperArrowRef = function (el) {
      _this.setState({
        arrowRef: el
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  NameTooltip.prototype.render = function render() {
    var _props = this.props,
        title = _props.title,
        classes = _props.classes,
        props = _objectWithoutProperties(_props, ["title", "classes"]);

    return React.createElement(Tooltip, _extends({
      TransitionComponent: Zoom,
      placement: "top-start",
      classes: {
        tooltip: classes.tooltip,
        popper: classes.popper,
        tooltipPlacementTop: classes.tooltipPlacementTop
      },
      PopperProps: {
        popperOptions: {
          modifiers: {
            arrow: {
              enabled: true,
              element: this.state.arrowRef
            }
          }
        }
      }
    }, props, {
      title: React.createElement(Fragment, null, title, React.createElement("span", {
        className: classes.arrow,
        ref: this.handlePopperArrowRef
      }))
    }));
  };

  return NameTooltip;
}(Component);

export default withStyles(styles)(NameTooltip);